import { toastr } from "react-redux-toastr";
const options = {
    timeOut: 8000,
    extendedTimeOut: 8000,
};

export function setErroAPI(e) {
    try {
        if (e.response.status == 400) {
            if (e.response.data instanceof Array) {
                e.response.data.forEach((retorno) => {
                    toastr.error("Erro", retorno.msg ? retorno.msg : retorno, options);
                });
            } else {
                toastr.error("Erro", e.response.data, options);
            }
        } else {
            toastr.error("Erro", "Erro ao realizar Operação!!", options);
        }
    } catch (erro) {
        toastr.error("Erro", "Falha ao validar erro!!", options);
    }
}

export function setSuccess(mensagem) {
    toastr.success("Sucesso", mensagem);
}

export function setInfo(mensagem) {
    toastr.info("Info", mensagem);
}

export function setWarning(mensagem) {
    toastr.warning("Aviso", mensagem);
}

export function setError(mensagem) {
    toastr.error("Alerta", mensagem);
}
